import "cryptlib";

export const decrypt = (input, secretKey) => {
  let output = "";
  try {
    const cryptLib = require("cryptlib");
    let key = cryptLib.getHashSha256(secretKey, 32); //32 bytes = 256 bit
    let iv = input.substring(0, 16);
    input = input.substring(16, input.length);
    output = cryptLib.decrypt(input, key, iv); //decrypt
  } catch (e) {
    // TODO Auto-generated catch block
    console.log("decrypt error : " + e);
    alert("Incorrect PIN. Please try again or contact us for assistance.")
  }
  return output;
};
